var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageDescription && _vm.pageDescriptionConfig.position == "bottom" && _vm.pageDescriptionConfig.content && _vm.itemIndex == _vm.arrNum ? _c("div", {
    staticStyle: {
      position: "relative",
      padding: "10px"
    }
  }, [_c("div", {
    staticClass: "page-content",
    style: {
      background: _vm.themeColor
    }
  }), _c("span", {
    staticClass: "page-font-content",
    style: {
      color: _vm.themeColor
    }
  }, [_vm._v(_vm._s(_vm.pageDescriptionConfig.content))])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "bottomButton1" || _vm.styleObj.controlsComponentsMark == "bottomButton2" ? _c("div", {
    staticClass: "bottomButtonBox",
    class: _vm.styleObj.controlsComponentsMark == "bottomButton2" ? "bottomButtonBox2" : "",
    style: !_vm.styleObj.isPremium || _vm.styleObj.controlsComponentsMark == "bottomButton1" ? "padding-right:0" : ""
  }, [_c("div", {
    staticClass: "moneyBox"
  }, [_c("div", {
    style: _vm.styleObj.buttonInfo[0].buttonBgColor == "#fff" ? "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor : "color:" + _vm.styleObj.buttonInfo[0].buttonBgColor
  }, [_vm._v(" 39.99 ")]), _vm._v(" " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + _vm.$t("/起")) + " ")]), _vm.styleObj.buttonInfo ? _c("div", {
    staticStyle: {
      height: "100%",
      display: "flex",
      "align-items": "center"
    }
  }, [_vm.styleObj.buttonInfo[2] ? _c("div", {
    staticClass: "btn",
    style: "color:" + _vm.styleObj.buttonInfo[2].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[2].buttonBgColor + ";border:1px solid " + _vm.styleObj.buttonInfo[2].buttonFontColor + ";margin-right: 6px;",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 2);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont btnCont2"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[2].buttonName || "按钮文案3") + " ")])]) : _vm._e(), _vm.styleObj.buttonInfo[1] ? _c("div", {
    staticClass: "btn",
    style: "color:" + _vm.styleObj.buttonInfo[1].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[1].buttonBgColor + ";border:1px solid " + _vm.styleObj.buttonInfo[1].buttonFontColor + ";margin-right: 6px;",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 1);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont btnCont2"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[1].buttonName || "按钮文案2") + " ")])]) : _vm._e(), _vm.styleObj.isPremium && _vm.styleObj.controlsComponentsMark == "bottomButton1" ? _c("div", {
    staticClass: "btn",
    style: "color:" + _vm.styleObj.buttonColor + ";border:1px solid" + _vm.styleObj.buttonColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("premiumlick");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保费试算")) + " ")]) : _vm.styleObj.isPremium && _vm.styleObj.controlsComponentsMark == "bottomButton2" ? _c("div", {
    staticClass: "btn",
    style: "color:" + _vm.styleObj.buttonColor + ";border:1px solid" + _vm.styleObj.buttonColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("premiumlick");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保费试算")) + " ")]) : _c("div", {
    staticClass: "btn2",
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[0].buttonBgColor + ";border:1px solid " + _vm.styleObj.buttonInfo[0].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 0);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[0].buttonName || _vm.$t("按钮文案")) + " ")])])]) : _vm._e()]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "bottomButton3" ? _c("div", {
    staticClass: "bottomButtonBox3",
    class: +_vm.styleObj.buttonInfo.length == 1 ? "bottomButtonBox3_1" : ""
  }, [_vm.styleObj.buttonInfo[2] ? _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[2].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[2].buttonBgColor + ";border:1px solid " + _vm.styleObj.buttonInfo[2].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 2);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[2].buttonName || _vm.$t("按钮文案") + "3") + " ")])]) : _vm._e(), _vm.styleObj.buttonInfo[1] ? _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[1].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[1].buttonBgColor + ";border:1px solid " + _vm.styleObj.buttonInfo[1].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 1);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[1].buttonName || _vm.$t("按钮文案") + "2") + " ")])]) : _vm._e(), _vm.styleObj.isPremium ? _c("div", {
    style: "color:" + _vm.styleObj.buttonColor + ";background:" + _vm.themeColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("premiumlick");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保费试算")) + " ")]) : _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[0].buttonBgColor + ";border: 1px solid" + _vm.styleObj.buttonInfo[0].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 0);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[0].buttonName || _vm.$t("按钮文案")) + " ")])])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "bottomButton4" ? _c("div", {
    staticClass: "bottomButtonBox4"
  }, [_vm.styleObj.isPremium ? _c("div", {
    style: "color:" + _vm.styleObj.buttonColor + ";background:" + _vm.themeColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("premiumlick");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保费试算")) + " ")]) : _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[0].buttonBgColor + ";border:1px solid" + _vm.styleObj.buttonInfo[0].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 0);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[0].buttonName || _vm.$t("按钮文案")) + " ")])]), _vm.styleObj.buttonInfo[1] ? _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[1].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[1].buttonBgColor + ";margin-top: 10px;border:1px solid " + _vm.styleObj.buttonInfo[1].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 1);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[1].buttonName || _vm.$t("按钮文案") + "2") + " ")])]) : _vm._e(), _vm.styleObj.buttonInfo[2] ? _c("div", {
    style: "color:" + _vm.styleObj.buttonInfo[2].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[2].buttonBgColor + ";margin-top: 10px;border:1px solid " + _vm.styleObj.buttonInfo[2].buttonFontColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("buttonModalClick", 2);
      }
    }
  }, [_c("div", {
    staticClass: "btnCont"
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[2].buttonName || _vm.$t("按钮文案") + "3") + " ")])]) : _vm._e()]) : _vm._e(), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };